export default function ContactInfo() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Contact Information</h2>
          <p className="text-lg text-gray-600">
            Reach out to us through any of these channels
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#5C4F8A] rounded-full mx-auto mb-6">
              <i className="fas fa-phone text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Call Us</h3>
            <a 
              href="tel:833-438-5542"
              className="text-lg text-[#5C4F8A] hover:text-[#4A3D72] font-semibold cursor-pointer"
            >
              833-438-5542
            </a>
            <p className="text-sm text-gray-600 mt-2">Mon - Fri, 8am - 6pm</p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-full mx-auto mb-6">
              <i className="fas fa-envelope text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Email Us</h3>
            <a 
              href="mailto:info@kalikarehomecare.com"
              className="text-lg text-orange-600 hover:text-orange-800 font-semibold cursor-pointer break-all"
            >
              info@kalikarehomecare.com
            </a>
            <p className="text-sm text-gray-600 mt-2">We'll respond within 24 hours</p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#5C4F8A] rounded-full mx-auto mb-6">
              <i className="fas fa-map-marker-alt text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Visit Us</h3>
            <a 
              href="https://www.google.com/maps/dir//201+King+of+Prussia+Rd+Suite+650,+Wayne,+PA+19089/@40.0437773,-75.4394648,12z"
              target="_blank"
              rel="noopener noreferrer"
              className="text-base text-[#5C4F8A] hover:text-[#4A3D72] font-semibold cursor-pointer"
            >
              201 King of Prussia Rd<br />
              Suite 650<br />
              Radnor, PA 19087
            </a>
          </div>
        </div>

        <div className="bg-[#5C4F8A] rounded-2xl p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="fas fa-clock text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold mb-6">Office Hours</h3>
            <div className="grid md:grid-cols-2 gap-6 text-lg">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <p className="font-semibold mb-2">Monday - Friday</p>
                <p className="text-white/90">8:00 AM - 6:00 PM</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <p className="font-semibold mb-2">Saturday - Sunday</p>
                <p className="text-white/90">Closed</p>
              </div>
            </div>
            <p className="mt-8 text-white/80 text-base">
              Emergency services available 24/7 for existing clients
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}